import { Promise } from 'core-js';
import Vue from 'vue';
import router from './../../router'

// import _ from "lodash";

import Notifications from './services/notifications';

const store = new Vue.observable({
  ready: false,
  userPushEndpoint: '',
  stats: {
    newCount: 0,
    hasNew: false
  }
})

let pushNotifications = [];

let eventbus = new Vue();

let UserStore;

const NotificationCollection = {
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  use: ({ userStore }) => {
    UserStore = userStore;
    console.log("NotificationCollection Use:",UserStore);
  },
  reset: () => {
    store.ready = false;
    store.userPushEndpoint = '';
    store.stats = {
      newCount: 0,
      hasNew: false
    };
  },
  init: async () => {
    if (!store.ready) {
      if(window.localStorage['userPushEndpoint']) store.userPushEndpoint = window.localStorage['userPushEndpoint'];

      NotificationCollection.getStats();

      console.log("NotificationCollection init");
      store.ready = true;
    }
  },
  eventbus,

  getStats: async () => {
    const stats = await Notifications.getStats({ignoreCache: true}).then(({data}) => data);
    if(!stats) return null;
    store.stats.newCount = stats.newCount || 0;
    store.stats.hasNew = stats.hasNew || false;

    return store.stats;
  },

  registerDevice: async () => {
    try {
      const PushNotifications = window?.parent?.Capacitor?.Plugins?.PushNotifications;
      if(!PushNotifications) throw new Error('No support for push notifications!');

      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions!');
      }

      let result = await PushNotifications.register();

      console.log("registerDevice", result);

      return result;
    } catch (error) {
      console.log("registerDevice Error", error)
    }
  },
  finaliseRegisterDevice: async ({token, platform}) => {
    if(!UserStore?.user?._id || !token || !platform) throw new Error('No token, platform or user specified!');
    let result = await Notifications.register({token, platform, idUser: UserStore.user._id});

    store.userPushEndpoint = result.endpointArn;
    window.localStorage['userPushEndpoint'] = result.endpointArn;

    return result;
  },
  deregisterDevice: async (endpointArn) => {
    try {
      endpointArn = endpointArn || window.localStorage['userPushEndpoint'];
      
      const PushNotifications = window?.parent?.Capacitor?.Plugins?.PushNotifications;
      if(!PushNotifications) throw new Error('No support for push notifications!');

      let result = await PushNotifications.unregister();
      await Notifications.deregister({endpointArn});
      store.userPushEndpoint = '';
      window.localStorage['userPushEndpoint'] = '';
      console.log("deregisterDevice", result);

      return result;
    } catch (error) {
      console.log("deregisterDevice Error", error);
    }
  },

  // get: (id) => store.notification[id],
  // getDetails: async (id) => {
  //   let notification = await Notifications.get(id, {ignoreCache: true}).then(({data}) => data);
  //   if(notification?._id) Vue.set(store.notification, notification._id, notification);
  //   return notification;
  // },
  acknowledge: async (id) => {
    await Notifications.acknowledge(id, {ignoreCache: true}).then(({data}) => data);
    NotificationCollection.getStats();
    const acknowledged = {_id: id, acknowledged: (new Date()).toJSON()};
    eventbus.$emit('acknowledge', acknowledged);
    return acknowledged;
  },
  acknowledgeAll: async () => {
    await Notifications.acknowledgeAll({ignoreCache: true}).then(({data}) => data);
    const acknowledged = {acknowledged: (new Date()).toJSON()};
    eventbus.$emit('acknowledge-all', acknowledged);

    store.stats.newCount = 0;
    store.stats.hasNew = false;

    return acknowledged;
  },
  remove: async (id) => {
    await Notifications.delete(id, {ignoreCache: true}).then(({data}) => data);
    NotificationCollection.getStats();
    const removed = {_id: id};
    eventbus.$emit('remove', removed);
    return removed;
  },
  removeAll: async () => {
    await Notifications.deleteAll({ignoreCache: true}).then(({data}) => data);
    eventbus.$emit('remove-all');
    
    store.stats.newCount = 0;
    store.stats.hasNew = false;

    return true;
  },

  // getAll: () => store.notification,
  // list: (options) => {
  //   let notifications = Object.values(store.notification);

  //   if(options && options.orderBy) return _.orderBy(notifications, [options.orderBy], [options.orderDirection || "asc"]);
  //   return notifications;
  // },

  add: ({ title, body, data = {} }) => {
    const created = new Date().toJSON();
    const { action, notificationId } = data;

    let notification = {
      _id: notificationId,
      title,
      body,
      action,
      created
    };
    // Vue.set(store.notification, notification._id, notification);

    eventbus.$emit('add', notification);

    NotificationCollection.getStats();

    if(!window.parent.CapacitorCustomPlatform) return;

    function newNotification({title, body, data}) {
      const notification = new Notification(title, {
        body,
        data: notificationId
      });

      notification.onclick = () => {
        NotificationCollection.clickFunction({title, body, data});
      };

      console.log(notification);

      pushNotifications.push(notification);

      return notification;
    }

    if (!("Notification" in window)) {
      // Check if the browser supports notifications
      alert("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
      // Check whether notification permissions have already been granted;
      // if so, create a notification
      newNotification({ title, body, data });
      // …
    } else if (Notification.permission !== "denied") {
      // We need to ask the user for permission
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          newNotification({ title, body, data });
        }
      });
    }
  },
  async clickFunction(notification = {}) {
    // alert(JSON.stringify(notification));
    await Vue.prototype.$hub.initialised();
    var user = Vue.prototype.$hub.getUser();
    if(!user) return;
    
    try {
      const { data: notificationData = {}, title = "" } = notification;
      let { action: actionData = {}, notificationId } = notificationData;

      NotificationCollection.acknowledge(notificationId);

      if(typeof actionData === "string") {
        try {
          actionData = JSON.parse(actionData);
        } catch (error) {
          console.log(error);
          actionData = {};
        }
      }

      const foundLocal = pushNotifications.find(noti => noti.data === notificationId);
      if(foundLocal) foundLocal.close();

      const PushNotifications = window.parent?.Capacitor?.Plugins?.PushNotifications;
      if(PushNotifications) {
        PushNotifications.getDeliveredNotifications().then(({ notifications }) => {
          // alert(JSON.stringify(notifications));
          const foundPush = notifications.find(({data = {}}) => data.notificationId === notificationId);
          if(foundPush) PushNotifications.removeDeliveredNotifications({notifications:[foundPush]}).then(res => console.log(res), err => console.log(err));
        }, err => console.log(err));
      }

      const { type, action, idContentShare, idGroup } = actionData;

      if(action === "open" && type === "invite") {
        return router.push({
          name: "main.settings.invitations"
        });
      } else if(action === "open" && type === "content-question-response") {
        eventbus.$emit('show-question-response', actionData);
      } else if(action === "open") {
        return router.push({
          name: "main.feed.content.viewer",
          params: {id: idContentShare},
          query: {
            groupId: idGroup,
            groupTitle: title
          },
        });
      }
    } catch (error) {
      console.log("ERROR",error);
      alert(JSON.stringify(error));
    }
  },

  newCount: () => store.stats.newCount,
  hasNew: () => store.stats.hasNew
}

export default NotificationCollection